<template>
	<div class="row" style="margin-top: 10px;">
		<div class="col-md-1">
			Федеральный округ
		</div>
		<div class="col-md-3">
			<select v-model="selected_fo" class='form-control my-control'>
				<option v-if="all" :value="-1">
					Все федеральные округа
				</option>
				<option v-for="option in options_fo" :value='option.id'>
					{{ option.name }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
	import {DB} from './../../constants'
	const GET_FO = 'get_fo.php'

	import {EventBus} from '../../lib/EventBus'

	export default {
		name: 'FoList',
		data: function () { 
			return {
				selected_fo: '',
				options_fo: []
			}
		},
		props: {
			all: false
		},
		watch: {
			selected_fo (val) {
				if(val == -1) {
					//select all FO
					EventBus.$emit(`change_fo`, {id: -1, name: 'Все федеральные округа'})
				} else {
					EventBus.$emit(`change_fo`, this.options_fo.find(e => {return e.id == val}))
				}
			}
		},
		methods: {
			fill_fo () {
				fetch(DB + GET_FO, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options_fo = data
						this.selected_fo = this.options_fo[0].id
						EventBus.$emit(`change_fo`, this.options_fo[0])
					}
					else {
						this.options_fo = []
						this.selected_fo = null
					}
				})
				.catch(err => console.log(err))
			}
		},
		created: function () {
			this.fill_fo()
		},
		beforeDestroy () {
		}
	}
</script>


// WEBPACK FOOTER //
// FoList.vue?6b8b206f